var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerMenos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.26 35.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 17otros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.26 26.44 92.31 28.65 46.63 8.9 0.95 28.65 0 26.44 46.15 6.49 47.11 6.49 93.26 26.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.26 19.95 92.31 22.16 46.63 2.41 0.95 22.16 0 19.95 46.15 0 47.11 0 93.26 19.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.26 32.93 92.31 35.14 46.63 15.39 0.95 35.14 0 32.93 46.15 12.98 47.11 12.98 93.26 32.93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerMenos);
export default __webpack_public_path__ + "static/media/ver-menos.0d1f63046c3daa00c55241c2d4e84f7c.svg";
export { ForwardRef as ReactComponent };